module.exports = __webpack_public_path__ + "img/icon_star_half.2f574b28.svg";